import React, { useState } from 'react';
import styles from './ComparisonChartRow.module.scss';
import cx from 'classnames';
import { Icon, Text } from '../index';
import { ICONS_PATH } from '../../lib/constants';

const ComparisonChartRowDesktop = (props) => {
    const { rowTitle, helpTipText } = props;
    const actualColumns = Object.keys(props).filter((k) => k.includes('columnContent')).length;
    const columns = [];
    const iconName = 'information-circle-grey-filled.svg';
    const [showHelpTip, setShowHelpTip] = useState(false);
    const [selectedHelpTip, setSelectedHelpTip] = useState(null);
    const rowHelpTipText = helpTipText ? `text-helptip-${helpTipText}` : null;

    const showHelpTipTrigger = (id) => {
        setShowHelpTip(true);
        setSelectedHelpTip(id);
    };
    const hideHelpTipTrigger = (id) => {
        setShowHelpTip(false);
        setSelectedHelpTip(id);
    };

    for (let colIndex = 0; colIndex < actualColumns; colIndex++) {
        const colText = props[`columnContent${colIndex + 1}`];
        const isHelpTipTextEmpty =
            !props[`helpTipText${colIndex + 1}`] ||
            !props[`helpTipText${colIndex + 1}`].length ||
            props[`helpTipText${colIndex + 1}`].length === 0;
        const helpTipText = !isHelpTipTextEmpty ? props[`helpTipText${colIndex + 1}`] : null;
        const helpTipId = !isHelpTipTextEmpty ? `${colIndex}-text-helptip-${helpTipText}` : null;
        const col = {
            colText: colText,
            helpTipId: helpTipId,
            showHelpTip: false,
            helpTipText: helpTipText,
        };
        columns.push(col);
    }

    return (
        <div className={cx(styles.root, styles[`columns--${actualColumns}`])} role="row">
            <div className={styles['column']} role="rowheader">
                <div className={cx(styles.wrapper)}>
                    <Text content={rowTitle} size="large" className={styles['column__content']} />
                    {rowHelpTipText && (
                        <div role="tooltip" className={cx(styles['helptip__container'])}>
                            <div
                                tabIndex={0}
                                aria-label="info:"
                                onFocus={() => showHelpTipTrigger(rowHelpTipText)}
                                onMouseOver={() => showHelpTipTrigger(rowHelpTipText)}
                                onMouseLeave={() => hideHelpTipTrigger(rowHelpTipText)}
                                className={cx(styles['helptip__icon'])}
                            >
                                <Icon url={ICONS_PATH + iconName} size={'xx-small'} />
                            </div>
                            {showHelpTip && selectedHelpTip === rowHelpTipText && (
                                <span
                                    className={cx(
                                        styles['helptip__text-container'],
                                        styles['helptip__text-container--right']
                                    )}
                                >
                                    <p
                                        tabIndex={0}
                                        id={rowHelpTipText}
                                        onMouseLeave={() => hideHelpTipTrigger(rowHelpTipText)}
                                        className={cx(styles['helptip__text-content'])}
                                    >
                                        {helpTipText}
                                    </p>
                                </span>
                            )}
                        </div>
                    )}
                </div>
            </div>
            {columns.map((column, index) => (
                <div className={styles['column']} key={index} role="cell">
                    <div className={cx(styles.wrapper)}>
                        <Text
                            size="large"
                            content={column.colText}
                            className={styles['column__content']}
                        />
                        {column.helpTipId != null && (
                            <div role="tooltip" className={cx(styles['helptip__container'])}>
                                <div
                                    tabIndex={0}
                                    aria-label="info:"
                                    onFocus={() => showHelpTipTrigger(column.helpTipId)}
                                    onMouseOver={() => showHelpTipTrigger(column.helpTipId)}
                                    onMouseLeave={() => hideHelpTipTrigger(column.helpTipId)}
                                    className={cx(styles['helptip__icon'])}
                                >
                                    <Icon url={ICONS_PATH + iconName} size={'xx-small'} />
                                </div>
                                {showHelpTip && selectedHelpTip === column.helpTipId && (
                                    <span
                                        className={cx(
                                            styles['helptip__text-container'],
                                            styles['helptip__text-container--right']
                                        )}
                                    >
                                        <p
                                            tabIndex={0}
                                            id={column.helpTipId}
                                            onBlur={() => hideHelpTipTrigger(column.helpTipId)}
                                            className={cx(styles['helptip__text-content'])}
                                        >
                                            {column.helpTipText}
                                        </p>
                                    </span>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ComparisonChartRowDesktop;
